module.exports = __webpack_public_path__ + "img/loading.fa877745.gif";